import { render, staticRenderFns } from "./hospitalpanel.vue?vue&type=template&id=110dde3e"
import script from "./hospitalpanel.vue?vue&type=script&lang=js"
export * from "./hospitalpanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports